module.exports = __webpack_public_path__ + "static/media/lock.b1d2cf20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lock.svg
// module id = 254
// module chunks = 0